import React, { Fragment, useEffect } from "react";
import ScrollToTop from "ScrollToTop";
import Routers from "./Navigation/Routers";
import { setDefaultHeader } from "./utils/httpClient";
import { bindGlobalLoaderRouteReset } from "./utils/globalLoader";
import { useDispatch, useSelector } from "react-redux";
import { jwtTokenGenrate } from "./reduxStore/action/authActions";
import MyErrorBoundary from "component/MyErrorBoundary";
import { useSessionStatusPoll, isActiveUserSession } from "./utils/sessionStatusPoll";

function App() {
  const dispatch = useDispatch();
  const loginSelector = useSelector((state) => state.login);
  useSessionStatusPoll(isActiveUserSession(loginSelector));

  useEffect(() => {
    bindGlobalLoaderRouteReset();
  }, []);

  useEffect(() => {
    if (loginSelector?.response == null) {
      tokenGenrate();
    } else {
      if (loginSelector?.response?.status === 200) {
        setDefaultHeader("token", loginSelector?.response?.token);
      }
    }
  }, [loginSelector]);

  async function tokenGenrate() {
    dispatch(jwtTokenGenrate());
  }
  return (
    <Fragment>
      <MyErrorBoundary>
        <ScrollToTop>
          <Routers />
        </ScrollToTop>
      </MyErrorBoundary>
    </Fragment>
  );
}

export default App;
